import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationInitService {
  constructor(private translate: TranslateService) {}

  async init() {
    this.translate.setDefaultLang('en'); // Set your default language
    await firstValueFrom(this.translate.use('en')); // Wait for the translations to load
  }
}
